import { Brand } from "@adora/shared/types/brand";
import useBrands from "./use-brands";

export const getBrandName = (brands: Brand[], brandId?: string) => {
  return brands.find((b) => b.id.toString() === brandId)?.name ?? "";
};

const useBrandName = (brandId?: string) => {
  const { brands } = useBrands();
  return brands ? getBrandName(brands, brandId) : "";
};

export default useBrandName;
